module.exports = __webpack_public_path__ + "media/savings_calculator/iFrame_widget-e569a8ca.png";